<i18n>
{
  "fr": {
    "static-page-content-not-found-error": "Aucune page n'a été trouvée pour cette url dans cette langue."
  },
  "en": {
    "static-page-content-not-found-error": "No page has been found for this url in this language."
  }
}
</i18n>

<template>
  <prismic-content :doctype="DOCUMENT_TYPE_STATIC_PAGE" :uid="$route.params.uid">
    <!-- Affichage du contenu de la page -->
    <template #default="{ content, response }">
      <div class="card">
        <ui-heading
          :title="$prismicText(content.title)"
          :details="
            $prismicText(content.subtitle)
              ? `${$prismicText(content.subtitle)} / ${$format.dateTime(response.last_publication_date)}`
              : $format.dateTime(response.last_publication_date)
          "
        />

        <ui-box class="py-48px">
          <div class="has-max-width-768">
            <component
              v-for="(fragment, index) in content.body"
              :key="index"
              :is="getComponent(fragment.slice_type)"
              :fragment="fragment"
            ></component>
          </div>
        </ui-box>
      </div>
    </template>
    <!-- Dans le cas ou on ne trouverais pas la page dans prismic -->
    <template #error>
      <p class="has-text-danger">{{ $t('static-page-content-not-found-error') }}</p>
    </template>
  </prismic-content>
</template>

<script>
import PrismicContent from '@/components/prismic/prismic-content'
import UiBox from '@/components/ui/box'
import UiHeading from '@/components/ui/heading'
import { DOCUMENT_TYPE_STATIC_PAGE } from '@/consts/prismic'
import Slices from '@/components/slices'

export default {
  components: { PrismicContent, UiBox, UiHeading },
  data() {
    return {
      DOCUMENT_TYPE_STATIC_PAGE
    }
  },
  methods: {
    getComponent(slice_type) {
      return Slices[slice_type]
    }
  }
}
</script>
